/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OktaProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * handle data from okta event hook
   * @returns any handle data from okta event hook
   * @throws ApiError
   */
  public postApiServicesecurityProcessesOktaAddSuperUser(): CancelablePromise<{
    data?: {
      success?: boolean;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/processes/okta/addSuperUser',
    });
  }

  /**
   * handle data from okta event hook
   * @returns any handle data from okta event hook
   * @throws ApiError
   */
  public getApiServicesecurityProcessesOktaAddSuperUser(): CancelablePromise<{
    verification?: string;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/okta/addSuperUser',
    });
  }

}
